<p-tree
[value]="treeData"
selectionMode="checkbox"
[(selection)]="selectedValues"
(onNodeSelect)="nodeSelect($event)"
(onNodeUnselect)="nodeSelect($event)"
[propagateSelectionUp]="true"
[propagateSelectionDown]="true"
></p-tree>